module.exports = __webpack_public_path__ + "img/sony-xperia-xa1-ultra.c0b81d4b.png";